import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IRelocationSites } from '../models/relocationSites';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class RelocationSitesService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getRelocationSites(buildingId: string): Observable<{has_error: boolean, message: string, data: IRelocationSites}> {
        const url = environment.apiBaseUrl + endpoints.getRelocationSites.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: IRelocationSites}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateRelocationSites(buildingId: string, data: Partial<IRelocationSites>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateRelocationSites.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
